import React from 'react'
import AlertDiv from '../ReRegistration/Forms/AlertDiv'
import { green, red, orange } from '@material-ui/core/colors'
import VerifiedUserIcon from '@material-ui/icons/VerifiedUser';
import { Button } from '@material-ui/core';



export default function HostelAdmissionIns({ history}) {
    return (
        <div>
             <div>
                
                <AlertDiv
                    border={green[300]}
                    back={green[50]}
                >
                 <VerifiedUserIcon style={{color: green[300]}} />  Click the button below to visit the <b>hostel admission panel</b>.
                  
                  <br />
                  <br />

                  <Button
                    size="small"
                    style={{
                        backgroundColor: green[700],
                        color: 'white',
                        borderRadius: 0
                    }}
                    variant="contained"
                    onClick={() => history.push(`/hostel-admission`)}
                  >
                      Hostel Admission Panel
                  </Button>
                </AlertDiv>
            </div>



          
        </div>
    )
}



// WEBPACK FOOTER //
// ./src/Components/HostelAdmission/HostelAdmissionIns.js